module.exports = __webpack_public_path__ + "static/media/meditate1.f6f8e591.jpg";